//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class BoardBackground extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'CustomBoardBackground';
  }
}
BoardBackground.initClass();

export { BoardBackground };
